<div
  class="fixed inset-0 z-[9999] flex h-screen w-screen items-center justify-center">
  <app-spinner />
</div>
